import { HTMLInputTypeAttribute, forwardRef } from "react";

interface Props<T = string> {
  inputIcon?: JSX.Element;
  required?: boolean;
  name?: string;
  value: string;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  handleChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
  dataTestId?: string;
}

export const TextInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    inputIcon,
    required,
    name,
    value,
    placeholder,
    type,
    handleChange,
    disabled = false,
    className = "",
    inputClassName = "",
    dataTestId,
  } = props;
  return (
    <>
      <div className={`flex w-full items-center py-0 gap-2 ${className}`}>
        {inputIcon}
        <input
          ref={ref}
          disabled={disabled}
          required={!!required}
          name={name || ""}
          value={value}
          placeholder={placeholder}
          type={type ? type : "text"}
          className={`relative outline-none w-full text-sm text-text_primary bg-transparent border-none ${inputClassName}`}
          onChange={(e) => handleChange(e.target.value)}
          // NOTE: used in e2e tests — do not remove
          data-testid={dataTestId}
        />
      </div>
    </>
  );
});
